import { Actions, Subjects } from 'constants/accessControlList';
import { useRbac } from 'shared/features/rbac';
import { useUserIdFromToken } from 'shared/hooks';
export var useCanEditUnscheduledInteraction = function (note) {
    var userId = useUserIdFromToken();
    var isMyNote = !note || (note === null || note === void 0 ? void 0 : note.ownerId) === userId;
    var canI = useRbac().canI;
    var canEditNote = isMyNote &&
        (canI(Actions.Edit, Subjects.UnscheduledInteractionsAllMembers) ||
            canI(Actions.Edit, Subjects.UnscheduledInteractionsMyMembers));
    return canEditNote;
};
